<script setup lang="ts">
// Sierra's .panel: flat, a 14 px radius on a hairline. The header has an uppercase
// title, an optional subtitle, and actions on the right. `flush` drops the body's
// padding, for tables and lists that run edge to edge.
withDefaults(defineProps<{ title?: string | undefined; subtitle?: string | undefined; flush?: boolean; grow?: boolean }>(), { flush: false, grow: false });
</script>

<template>
  <section class="itc-panel" :class="{ 'itc-panel--grow': grow }">
    <header v-if="title || $slots.actions" class="itc-panel__head">
      <div>
        <h2 v-if="title" class="itc-panel__title">{{ title }}</h2>
        <div v-if="subtitle" class="itc-panel__sub">{{ subtitle }}</div>
      </div>
      <div v-if="$slots.actions" class="itc-panel__actions"><slot name="actions" /></div>
    </header>
    <div :class="{ 'itc-panel__body': !flush }"><slot /></div>
  </section>
</template>
